const accordionHeaders = document.querySelectorAll('[js-accordion-header]');
if (accordionHeaders) {
  accordionHeaders.forEach((header) => {
    header.addEventListener('click', () => {
      const parent = header.parentElement;
      const content = parent.querySelector('[js-accordion-content]');

      accordionHeaders.forEach((otherHeader) => {
        const otherParent = otherHeader.parentElement;
        const otherContent = otherParent.querySelector('[js-accordion-content]');
        if (otherParent !== parent) {
          otherParent.classList.remove('active');
          otherContent.style.height = 0;
        }
      });

      parent.classList.toggle('active');
      if (parent.classList.contains('active')) {
        content.style.height = content.scrollHeight + 'px';
      } else {
        content.style.height = 0;
      }
    });
  });
}


// const iconWithText = document.querySelector('[js-hb-icon-with-text]');
// if (iconWithText) {
//   const hbTabs = iconWithText.querySelectorAll('[js-hb-tabs]');
//   const hbTabContent = iconWithText.querySelectorAll('[js-hb-tab-content]');
//   const handleTabClick = (index) => {
//     hbTabs.forEach((tab) => {
//       tab.classList.remove('is-selected');
//     });
//     hbTabContent.forEach((content) => {
//       content.classList.remove('is-active');
//     });
//     hbTabs[index].classList.add('is-selected');
//     hbTabContent[index].classList.add('is-active');
//   };
//   const updateTabsForViewport = () => {
//     if (window.innerWidth <= 767) {
//       hbTabContent[0].classList.add('is-active');
//       hbTabs[0].classList.add('is-selected');

//       hbTabs.forEach((tab, index) => {
//         tab.addEventListener('click', () => handleTabClick(index));
//       });
//     }
//   };
//   updateTabsForViewport();
//   window.addEventListener('resize', updateTabsForViewport);
// }

class collectionGridItem extends HTMLElement {
  constructor() {
    super();

    this.mainCollection = document.querySelector(".main-collection");
    this.desktopPosition = parseInt(this.dataset.desktopPosition);
    this.mobilePosition = parseInt(this.dataset.mobilePosition);
  };

  init() {
    this.appendGridItem();
  };

  connectedCallback() {
    this.init();
  }

  appendGridItem() {
    if (document.documentElement.clientWidth > 767) {
      const targetProductItem = this.mainCollection.querySelector(`#collectionGrid .product-item:nth-child(${this.desktopPosition})`);

      if (targetProductItem) {
        targetProductItem.insertAdjacentHTML("afterEnd", this.innerHTML)
      } else {
        this.mainCollection.querySelector("#collectionGrid").insertAdjacentHTML("beforeEnd", this.innerHTML)
      }
    } else {
      const targetProductItem = this.mainCollection.querySelector(`#collectionGrid .product-item:nth-child(${this.mobilePosition})`);

      if (targetProductItem) {
        targetProductItem.insertAdjacentHTML("afterEnd", this.innerHTML)
      } else {
        this.mainCollection.querySelector("#collectionGrid").insertAdjacentHTML("beforeEnd", this.innerHTML)
      }
    }
  };
}

customElements.define('collection-grid-item', collectionGridItem);

function initCartUpsellSlider() {
  new Swiper(document.querySelector('[hb-js-cart-upsell-slide]'), {
    slidesPerView: 1.508,
    spaceBetween: 16,
    breakpoints: {
      0: {
        slidesPerView: 1.2,
      },
      768: {
        slidesPerView: 1.508,
      },
    },
  });
};

initCartUpsellSlider();
document.addEventListener("cart-upsell-slider:init", initCartUpsellSlider);


if (document.querySelector("[js-swiper-tabs]")) {
  let swiperTabsInstance;
  function initSwiper() {
    if (!swiperTabsInstance && window.innerWidth < 768) {
      swiperTabsInstance = new Swiper('[js-swiper-tabs]', {
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
          el: '.js-swiper-pagination',
          clickable: true,
        },
      });
    } else if (swiperTabsInstance && window.innerWidth > 768) {
      swiperTabsInstance.destroy(true, true);
      swiperTabsInstance = null;
    }
  }

  initSwiper();
  window.addEventListener('resize', initSwiper);
}

const collectPoints = document.querySelectorAll('[js-collect-points]');
collectPoints.forEach((collectPoint) => {
  collectPoint.querySelectorAll('[js-collect-point-swiper]').forEach((swiperContainer) => {
    new Swiper(swiperContainer, {
      spaceBetween: 51,
      mousewheel: false,
      pagination: {
        el: swiperContainer.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: swiperContainer.querySelector('.swiper-button-next'),
        prevEl: swiperContainer.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 16,
        },
        480: {
          slidesPerView: 1.4,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 25,
        },
        1280: {
          slidesPerView: 3.2,
          spaceBetween: 51,
        },
      },
    });
  });
});